import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Loader2, AlertCircle } from 'lucide-react';
import { submitForm } from '../../utils/forms';

export function GuideCapture() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      await submitForm({
        formType: 'Guide',
        email
      });

      navigate('/thank-you');
    } catch (error) {
      setError(error instanceof Error ? error.message : 'An unexpected error occurred');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto text-center py-12 px-4">
      <div className="bg-black/50 border border-green-500/20 rounded-lg p-8">
        <h2 className="text-2xl font-bold text-white mb-4">
          Get Your Free Guide
        </h2>
        
        <p className="text-xl text-gray-300 mb-8">
          Learn how to reduce costs and save time with our AI solutions guide
        </p>

        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              className="w-full pl-12 pr-4 py-3"
            />
          </div>

          {error && (
            <div className="mt-4 flex items-center justify-center gap-2 text-red-500 text-sm">
              <AlertCircle className="w-4 h-4" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting || !email}
            className="w-full mt-4 px-6 py-3 bg-green-500 text-black font-bold rounded-lg
              hover:bg-green-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? (
              <span className="flex items-center justify-center gap-2">
                <Loader2 className="w-5 h-5 animate-spin" />
                Sending...
              </span>
            ) : (
              'Send Me a Free Guide'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}